import { conversionRateBus } from "@/event/conversionRateBus"

export function convertPriceToEuroHappy(price: number | string) {
    const priceNumber = typeof price === 'string' ? Number(price) : price
    const convertedPrice = priceNumber * conversionRateBus.value

    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(convertedPrice)
}